
// ── Platform tab component ────────────────────────────────────────────────────
// The CLI is the preferred path, so it leads and is every guide's default tab.
// `curl` keeps the raw-API recipe for anyone who wants it; the CI tabs drive the
// CLI, which picks up the runner's ambient OIDC identity with no stored secret.
export type Platform = 'cli' | 'curl' | 'github' | 'gitlab'

export const PLATFORM_LABELS: Record<Platform, string> = {
  cli:    'Terramantle CLI',
  curl:   'curl',
  github: 'GitHub Actions',
  gitlab: 'GitLab CI',
}

export const ALL_PLATFORMS = Object.keys(PLATFORM_LABELS) as Platform[]

export function PlatformTabs({ value, onChange, only }: { value: Platform; onChange: (p: Platform) => void; only?: Platform[] }) {
  return (
    <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
      {(only ?? ALL_PLATFORMS).map((p) => (
        <button
          key={p}
          onClick={() => onChange(p)}
          className="btn btn-ghost btn-sm"
          style={{
            fontFamily: 'var(--mono)',
            fontSize: '0.68rem',
            opacity: value === p ? 1 : 0.45,
            borderBottom: value === p ? '1px solid var(--accent)' : '1px solid transparent',
            borderRadius: 0,
            paddingBottom: 5,
          }}
        >
          {PLATFORM_LABELS[p]}
        </button>
      ))}
    </div>
  )
}
